import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { LoginService } from '../../../../login/login.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { MatDialog } from '@angular/material/dialog';
import {
  ICamara,
  ICamaraAlarma,
  ICliente,
  IComunicadorAlarma,
  IControlHorarioDetalles,
  ICreateDispositivoAlarma,
  ICredencialesAlarma,
  ICreateNota,
  ICreateUbicacion,
  IDispositivoAlarma,
  IExcepcion,
  IFilter,
  IGeoJSONPoint,
  IModeloDispositivo,
  INota,
  IParticionZona,
  IPopulate,
  IQueryParam,
  IServicioContratado,
  ISensorPorZona,
  IUbicacion,
  IUpdateUbicacion,
  Operador,
  Dia,
  FormatosMensajeComunicador,
} from 'modelos/src';
import { firstValueFrom, Observable, Subscription } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ParamsService } from '../../../../../auxiliares/servicios/params.service';
import { AgregarCanalCamaraCompletoComponent } from './agregar-canal-camara-completo/agregar-canal-camara-completo.component';
import { AgregarHorarioCompletoComponent } from './agregar-horario-completo/agregar-horario-completo.component';
import { VisualizadorHorarioComponent } from './visualizador-horario/visualizador-horario.component';
import { CrearNotaAlarmaCompletoComponent } from './crear-editar-nota-alarma-completo/crear-editar-nota-alarma-completo.component';
import { DetallesNotaComponent } from '../../../../standalone/notas/detalles-nota/detalles-nota.component';
import { MatStepper, MatStepperIntl } from '@angular/material/stepper';
import { UbicacionService } from '../../../../../auxiliares/servicios/http/ubicacion.service';
import { AlarmasDomiciliariasService } from '../alarmas-domiciliarias.service';
import { NotasService } from '../../../../../auxiliares/servicios/http/notas.service';
import { ActivatedRoute } from '@angular/router';
import { AgregarInfoZonaCompletoComponent } from './agregar-infozona-completo/agregar-infozona-completo.component';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { PermisosEntidadesService } from '../../../../../auxiliares/servicios/http/permisos-entidades.service';
import { OrigenService } from '../../../../../auxiliares/servicios/origen.service';
import { ModeloDispositivoSelectorCacheService } from '../../../../../componentes/selectores/modelo-dispositivo-selector/modelo-dispositivo-selector-cache.service';
import { ExcepcionsService } from '../../../../../auxiliares/servicios/http/excepcions.service';
import { CrearEditarCamaraComponent } from '../../../camaras/crear-editar-camara/crear-editar-camara.component';
import { ChequeoIdentificacion } from '../../../../../auxiliares/servicios/chequeo-identificacion';
import { SimsService } from '../../../../../auxiliares/servicios/http/sims.service';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';

@Component({
  selector: 'app-crear-alarma-domiciliaria-completo',
  templateUrl: './crear-alarma-domiciliaria-completo.component.html',
  styleUrl: './crear-alarma-domiciliaria-completo.component.scss',
  providers: [{ provide: MatStepperIntl }],
  standalone: false,
})
export class CrearAlarmaDomiciliariaCompletoComponent
  implements OnInit, OnDestroy
{
  helper = inject(HelperService);
  dialog = inject(MatDialog);
  private formularios = inject(FormularioDialogService);
  permisosEntidades = inject(PermisosEntidadesService);
  private modeloCache = inject(ModeloDispositivoSelectorCacheService);
  private lista2 = inject(Lista2Service);
  private paramsService = inject(ParamsService);
  private ubicacionService = inject(UbicacionService);
  private alarmasService = inject(AlarmasDomiciliariasService);
  private notasService = inject(NotasService);
  private excepcionesService = inject(ExcepcionsService);
  private route = inject(ActivatedRoute);
  private simsService = inject(SimsService);
  private origen = inject(OrigenService);

  /**
   * Hasta tener todo (alarma, modelos, formularios y listados) se muestra el
   * spinner del marco. Antes el marco aparecía con los botones y el cuerpo
   * vacío hasta que terminaba listarTodo, y los pasos llegaban de golpe.
   * Sin el LoadingService global: prendía además el spinner de la barra
   * superior, y al guardar hacía desaparecer los pasos. Guardar se ve en el
   * botón (guardando).
   */
  public cargando = true;
  public title?: string;
  public subtitle?: string;
  @ViewChild('stepper') stepper: MatStepper;
  private _matStepperIntl = inject(MatStepperIntl);
  public formNotas: FormGroup[];
  public miCliente = LoginService.getCliente();
  // Editar
  public id?: string;
  public tab?: string;
  public alarmaEditar?: IDispositivoAlarma;

  // Warnings duplicados
  public warnNumeroAbonado = false;
  public warnNroDeSistema = false;

  public chequeo = new ChequeoIdentificacion<IDispositivoAlarma>({
    entidad: 'alarma',
    articulo: 'una',
    campo: 'nombre',
    control: () => this.formBasica?.get('nombre'),
    listar: (query) => this.alarmasService.getFiltered(query),
    idCliente: () => this.idCliente,
    excluirId: () => this.id,
  });

  // Listars
  public camaras: ICamara[];
  public ubicaciones: IUbicacion[] = [];
  public servicios: IServicioContratado[] = [];
  public notas: INota[] = [];

  // Subs
  private camaras$: Subscription;
  public domicilio$?: Subscription;
  public ubicaciones$?: Subscription;
  public servicios$: Subscription;
  public notas$: Subscription;
  /** Revalida el idUnicoComunicador cuando cambia el cliente: el duplicado se
   *  busca dentro del tenant de ese cliente. */
  private idClienteCambia$?: Subscription;

  // Basica
  public formBasica: FormGroup = null;
  // Detallada
  public formDetallada: FormGroup = null;
  public formControlHorario: FormGroup = null;

  // Formato aportado por cada modelo. El comunicador es opcional: hay paneles
  // con comunicación integrada (y alarmas sin comunicador cargado), en cuyo
  // caso el formato lo define el modelo de la alarma.
  private formatoDelComunicador?: FormatosMensajeComunicador;
  private formatoDelModelo?: FormatosMensajeComunicador;

  /** Formato efectivo: comunicador si hay, si no el del modelo de alarma. */
  public get formatoComunicador(): FormatosMensajeComunicador | undefined {
    return this.formatoDelComunicador ?? this.formatoDelModelo;
  }

  /**
   * DX Control se identifica por el IMEI del módulo, no por la cuenta Contact
   * ID. 'DX Control' ya está en gestion-modelos, pero el lock de esta web
   * todavía no: se compara como string hasta refrescarlo.
   */
  public get esDXControl(): boolean {
    return (this.formatoComunicador as string | undefined) === 'DX Control';
  }

  /**
   * El comunicador sólo es opcional cuando el modelo de la alarma ya aporta
   * formato (panel con comunicación integrada). Si el panel no lo define, sin
   * comunicador la API no puede rutear ningún comando → sigue siendo requerido.
   */
  public get comunicadorRequerido(): boolean {
    return !this.formatoDelModelo;
  }

  /**
   * Cartel bajo los dos selectores. Aparece recién cuando hay modelo de alarma
   * elegido (que es obligatorio): antes de eso no hay nada que informar.
   * Dice si el panel trae formato propio —y entonces el comunicador es
   * opcional— o si hace falta un comunicador que tenga formato cargado.
   */
  public get avisoFormato(): {
    tipo: 'info' | 'warning';
    texto: string;
  } | null {
    if (!this.formDetallada?.get('idModelo')?.value) return null;

    const delModelo = this.formatoDelModelo;
    const delComunicador = this.formatoDelComunicador;
    const hayComunicador = !!this.comunicadoresForm?.at(0)?.get('idComunicador')
      ?.value;

    // Comunicador elegido pero sin formato cargado en su modelo: no aporta
    // nada al ruteo. Se avisa aparte, pero no bloquea el guardado.
    if (hayComunicador && !delComunicador) {
      return {
        tipo: 'warning',
        texto: delModelo
          ? `El comunicador seleccionado no tiene formato cargado, así que no aporta nada: se va a usar el del modelo de alarma ("${delModelo}").`
          : 'El comunicador seleccionado no tiene formato cargado. Sin un comunicador con formato no se podrán enviar comandos a la alarma.',
      };
    }

    if (delComunicador) {
      return {
        tipo: 'info',
        texto: `Se va a usar el formato del comunicador: "${delComunicador}".`,
      };
    }

    if (delModelo) {
      return {
        tipo: 'info',
        texto: `El modelo de alarma define el formato "${delModelo}" (comunicación integrada). El comunicador es opcional; si cargás uno, el formato del comunicador tendrá prioridad.`,
      };
    }

    return {
      tipo: 'warning',
      texto:
        'Sin un comunicador con formato no se podrán enviar comandos a la alarma.',
    };
  }

  public tipoCliente = HelperService.getTipoCliente();
  public clientePropio = LoginService.getClientePropio();

  get mostrarCamposCliente(): boolean {
    return this.tipoCliente !== 'Final';
  }

  public createForms() {
    // Determinar el cliente por defecto basado en el tipo de usuario
    const clienteDefault =
      this.tipoCliente === 'Final'
        ? this.clientePropio._id
        : (this.alarmaEditar?.idCliente ?? this.miCliente?._id);

    /// Paginas (Básica - Detallada - Zonas - Cámaras - Ubicación)
    this.formBasica = new FormGroup({
      nombre: new FormControl(
        this.alarmaEditar?.nombre,
        Validators.required,
        this.chequeo.validador,
      ),
      numeroAbonado: new FormControl(
        this.alarmaEditar?.numeroAbonado,
        Validators.required,
      ),
      idCliente: new FormControl(clienteDefault, Validators.required),
      idsClientesQuePuedenAtender: new FormControl(
        this.alarmaEditar?.idsClientesQuePuedenAtender ?? null,
      ),
      idsClientesQuePuedenAtenderEventosTecnicos: new FormControl(
        this.alarmaEditar?.idsClientesQuePuedenAtenderEventosTecnicos ?? null,
      ),
      configHorariosAtencion: new FormControl(
        this.alarmaEditar?.configHorariosAtencion ??
          (this.miCliente?._id ? [{ idCliente: this.miCliente._id }] : null),
      ),
      configHorariosAtencionTecnica: new FormControl(
        this.alarmaEditar?.configHorariosAtencionTecnica ??
          (this.miCliente?._id ? [{ idCliente: this.miCliente._id }] : null),
      ),
      puedeSolicitarServicioTecnico: new FormControl(
        this.alarmaEditar?.puedeSolicitarServicioTecnico ?? false,
      ),
      idServiciosContratados: new FormControl(
        this.alarmaEditar?.idServiciosContratados,
      ),
    });
    ///
    this.formDetallada = new FormGroup({
      idUnicoComunicador: new FormControl(
        this.alarmaEditar?.idUnicoComunicador,
        Validators.required,
        [this.validarIdUnicoComunicador.bind(this)],
      ),
      // Todos los comunicadores de la alarma (mismo idUnicoComunicador,
      // protocolo/marca distinto entre sí) se editan igual, en una lista
      // uniforme. El primero (índice 0) es el que define el formato/aviso
      // de número de sistema — ver comunicadorRequerido/avisoFormato — pero
      // no es un campo especial a nivel de esquema, cualquier ítem se puede
      // borrar o agregar.
      comunicadores: new FormArray<FormGroup>([]),
      nroDeSistema: new FormControl(this.alarmaEditar?.nroDeSistema),
      idModelo: new FormControl(
        this.alarmaEditar?.idModelo,
        Validators.required,
      ),
      sim1: new FormGroup({
        // SIM vinculada o elegida en el selector de disponibles
        _id: new FormControl(this.alarmaEditar?.sim1?._id),
        iccid: new FormControl(this.alarmaEditar?.sim1?.iccid),
        numero: new FormControl(this.alarmaEditar?.sim1?.numero),
        operador: new FormControl(this.alarmaEditar?.sim1?.operador),
        apn: new FormControl(this.alarmaEditar?.sim1?.apn),
        usuario: new FormControl(this.alarmaEditar?.sim1?.usuario),
        password: new FormControl(this.alarmaEditar?.sim1?.password),
      }),
      sim2: new FormGroup({
        // SIM vinculada o elegida en el selector de disponibles
        _id: new FormControl(this.alarmaEditar?.sim2?._id),
        iccid: new FormControl(this.alarmaEditar?.sim2?.iccid),
        numero: new FormControl(this.alarmaEditar?.sim2?.numero),
        operador: new FormControl(this.alarmaEditar?.sim2?.operador),
        apn: new FormControl(this.alarmaEditar?.sim2?.apn),
        usuario: new FormControl(this.alarmaEditar?.sim2?.usuario),
        password: new FormControl(this.alarmaEditar?.sim2?.password),
      }),
      frecReporte: new FormControl(this.alarmaEditar?.frecReporte),
      // Credenciales propias de la alarma (opcional). Si quedan vacías, el backend
      // usa las del cliente (config.credencialesAlarmas).
      credencialesAlarma: new FormGroup({
        usuario: new FormControl(
          this.alarmaEditar?.credencialesAlarma?.usuario,
        ),
        password: new FormControl(
          this.alarmaEditar?.credencialesAlarma?.password,
        ),
        apikey: new FormControl(this.alarmaEditar?.credencialesAlarma?.apikey),
        apisecret: new FormControl(
          this.alarmaEditar?.credencialesAlarma?.apisecret,
        ),
      }),
    });
    ///
    (this.alarmaEditar?.comunicadores ?? []).forEach(
      (item: IComunicadorAlarma) => {
        this.comunicadoresForm.push(this.addComunicadorFormGroup(item));
      },
    );
    ///
    if (this.alarmaEditar) {
      this.alarmaEditar?.infoZonas?.forEach((zona) => {
        this.formInfoZonas?.push(this.addInfoZonaFormGroup(zona));
      });
    }
    ///
    this.formCamaras = new FormGroup({
      idsCamaras: new FormControl(this.alarmaEditar?.idsCamaras),
      camaras: new FormArray([]),
    });
    if (this.alarmaEditar) {
      this.alarmaEditar?.camarasPorZona?.forEach((camara) => {
        this.camarasForm.push(this.addCamaraFormGroup(camara));
      });
    }
    //
    this.formControlHorario = new FormGroup({
      activo: new FormControl(
        this.alarmaEditar?.controlHorario?.activo ?? false,
      ),
      ignorarArmadosFueraDeHorario: new FormControl(
        this.alarmaEditar?.controlHorario?.ignorarArmadosFueraDeHorario ??
          false,
      ),
      ignorarDesarmadosFueraDeHorario: new FormControl(
        this.alarmaEditar?.controlHorario?.ignorarDesarmadosFueraDeHorario ??
          false,
      ),
      horarios: new FormArray([]),
    });
    if (this.alarmaEditar) {
      this.alarmaEditar?.controlHorario?.horarios?.forEach((horario) => {
        this.horariosForm.push(this.addHorarioFormGroup(horario));
      });
      // Actualizar el estado activo basado en si hay horarios
      // this.formControlHorario
      //   .get('activo')
      //   ?.setValue(this.horariosForm.controls.length > 0);
    }
    //
    this.formUbicacion = new FormGroup({
      geojson: new FormGroup({
        type: new FormControl('Point'),
        coordinates: new FormControl(
          this.alarmaEditar?.domicilio?.geojson?.coordinates,
          Validators.required,
        ),
      }),
      domicilio: new FormControl(
        this.alarmaEditar?.domicilio?.direccion,
        Validators.required,
      ),
    });
    this.domicilio = this.alarmaEditar?.domicilio;
    this.domicilioExistente = true;
    this.domicilioId = this.alarmaEditar?.domicilio?._id;

    // En edición los selectores no emiten (modeloChange) al resolver el id
    // guardado, así que sembramos el formato buscando el modelo del
    // comunicador PRINCIPAL (comunicadores[0]) por id.
    this.formatoDelComunicador = this.modeloCache.getModeloPorIdSync(
      this.alarmaEditar?.comunicadores?.[0]?.idComunicador,
    )?.formatoMensaje;
    this.formatoDelModelo = this.alarmaEditar?.modelo?.formatoMensaje;
    this.actualizarRequeridoComunicador();

    // Configurar validación condicional para número de sistema
    this.setupValidacionCondicional();

    // El duplicado de idUnicoComunicador se busca dentro del tenant del cliente,
    // y el cliente vive en formBasica mientras el comunicador vive en
    // formDetallada. Si no se revalida al cambiarlo, queda el resultado del
    // cliente anterior: puede bloquear un número que en el tenant nuevo está
    // libre, o dejar pasar uno que ahí ya existe.
    this.idClienteCambia$?.unsubscribe();
    this.idClienteCambia$ = this.formBasica
      .get('idCliente')
      ?.valueChanges.subscribe(() => {
        this.formDetallada
          .get('idUnicoComunicador')
          ?.updateValueAndValidity({ emitEvent: false });
      });
    //
  }

  //Validador asíncrono para verificar si el idUnicoComunicador ya existe

  private async validarIdUnicoComunicador(
    control: AbstractControl,
  ): Promise<{ [key: string]: any } | null> {
    if (!control.value || control.value.trim() === '') {
      return null;
    }

    // Si estamos editando y el ID es el mismo que el original, no validar
    if (
      this.alarmaEditar?.idUnicoComunicador &&
      control.value === this.alarmaEditar.idUnicoComunicador
    ) {
      return null;
    }

    // El ámbito es el TENANT del cliente de la alarma: su cliente de nivel 1 y
    // todo lo que cuelgue de él. Sin el idCliente la API responde global, y eso
    // rechaza el mismo comunicador en tenants distintos, que es válido.
    const idCliente = this.idCliente;
    if (!idCliente) {
      return null;
    }

    try {
      const existe = await this.alarmasService.hayIdComunicador(
        control.value,
        idCliente,
        this.id ?? undefined,
      );
      return existe ? { idExistente: true } : null;
    } catch (error) {
      console.error('Error al validar idUnicoComunicador:', error);
      return null;
    }
  }

  /**
   * Configura la validación del número de sistema/serie
   * El campo no es obligatorio pero se muestra una advertencia si está vacío
   */
  private setupValidacionCondicional(): void {
    const nroSistemaControl = this.formDetallada.get('nroDeSistema');
    if (nroSistemaControl) {
      // El campo no es obligatorio en el formulario
      nroSistemaControl.clearValidators();
      nroSistemaControl.updateValueAndValidity();
    }
  }

  get formSim1() {
    return this.formDetallada?.get('sim1') as FormGroup;
  }
  get formSim2() {
    return this.formDetallada?.get('sim2') as FormGroup;
  }
  get formCredencialesAlarma() {
    return this.formDetallada?.get('credencialesAlarma') as FormGroup;
  }

  /**
   * Devuelve las credenciales propias de la alarma SOLO si tienen algún dato cargado.
   * Si están todas vacías retorna undefined → el backend usará las credenciales del
   * cliente (config.credencialesAlarmas).
   */
  private buildCredencialesAlarma(): ICredencialesAlarma | undefined {
    const c = this.formCredencialesAlarma?.value ?? {};
    const tieneAlgo = c.usuario || c.password || c.apikey || c.apisecret;
    if (!tieneAlgo) return undefined;
    return {
      usuario: c.usuario || undefined,
      password: c.password || undefined,
      apikey: c.apikey || undefined,
      apisecret: c.apisecret || undefined,
    };
  }

  // Zonas
  public formInfoZonas = new FormArray([]);

  get arrayZonas() {
    return this.formInfoZonas.controls;
  }
  filteredOptionsSim1 = new Observable<string[]>();
  filteredOptionsSim2 = new Observable<string[]>();
  public creandoNuevoTag?: boolean = false;

  public operadores: Operador[] = [
    'Claro',
    'Movistar',
    'Personal',
    'Tuenti',
    'Otro',
  ];

  /**
   * Se ejecuta cuando el usuario cambia el modelo de comunicador
   * Solo es necesario para asegurar que formDetallada es válido
   */
  public onComunicadorChange(idComunicadorSeleccionado: string): void {
    // El cambio de formato se detecta automáticamente a través de getFormatoComunicador()
  }

  /**
   * Formato aportado por el modelo de comunicador seleccionado (opcional).
   */
  public setFormatoComunicador(comunicador: IModeloDispositivo) {
    this.formatoDelComunicador = comunicador?.formatoMensaje || undefined;
  }

  /**
   * Formato aportado por el modelo de alarma seleccionado. Sólo aplica cuando
   * no hay comunicador externo (panel con comunicación integrada).
   */
  public setFormatoModelo(modelo: IModeloDispositivo) {
    this.formatoDelModelo = modelo?.formatoMensaje || undefined;
    this.actualizarRequeridoComunicador();
  }

  /**
   * Sincroniza el validator de `idComunicador` del PRIMER comunicador con el
   * formato del panel: el panel define cómo se comunica → comunicador
   * opcional; no lo define → requerido, porque es la única fuente de
   * formato que queda. Los demás ítems de la lista siempre son opcionales
   * en sí mismos (agregar uno vacío no tiene sentido, pero no bloquea).
   */
  private actualizarRequeridoComunicador(): void {
    const control = this.comunicadoresForm?.at(0)?.get('idComunicador');
    if (!control) return;
    if (this.comunicadorRequerido) {
      control.setValidators(Validators.required);
    } else {
      control.clearValidators();
    }
    control.updateValueAndValidity({ emitEvent: false });
  }

  // Todos los comunicadores de la alarma, en una sola lista uniforme: mismo
  // idUnicoComunicador entre todos, protocolo/marca distinto por ítem (el
  // protocolo vive en el MODELO de comunicador elegido — ver
  // ProtocoloComunicadorSchema en gestion-modelos — no se elige acá, para
  // que no se pueda desalinear del modelo). No hay un "principal" especial a
  // nivel de esquema — cualquiera se puede agregar o borrar, aunque el
  // primero (índice 0) es el que alimenta el formato/aviso de número de
  // sistema (ver comunicadorRequerido).
  get comunicadoresForm(): FormArray<FormGroup> {
    return this.formDetallada?.get('comunicadores') as FormArray<FormGroup>;
  }

  private addComunicadorFormGroup(item?: IComunicadorAlarma) {
    return new FormGroup({
      idComunicador: new FormControl(item?.idComunicador),
      passwordComunicador: new FormControl(item?.passwordComunicador),
    });
  }

  public addComunicador(): void {
    this.comunicadoresForm.push(this.addComunicadorFormGroup());
  }

  public deleteComunicador(i: number): void {
    this.comunicadoresForm.removeAt(i);
    this.actualizarRequeridoComunicador();
  }

  //camaras
  public formCamaras: FormGroup;
  get camarasForm() {
    return this.formCamaras?.get('camaras') as FormArray;
  }
  get arrayCamaras() {
    return this.camarasForm.controls;
  }
  public camarasDeAlarma?: ICamara[] = [];
  // control horario
  get horariosForm() {
    return this.formControlHorario?.get('horarios') as FormArray;
  }
  get controlHorarioActivo(): boolean {
    return this.formControlHorario?.get('activo')?.value ?? false;
  }

  public toggleControlHorario(): void {
    const currentValue = this.controlHorarioActivo;
    this.formControlHorario?.patchValue({ activo: !currentValue });
  }
  //ubication
  public formUbicacion: FormGroup = null;
  public domicilioExistente = false;
  public domicilio?: IUbicacion = null;
  public domicilioId: string = null;
  public centrarA?: IGeoJSONPoint;
  get geojson() {
    return this.formUbicacion?.get('geojson') as FormGroup;
  }
  //notas
  public notasForm = new FormArray([]);
  get arrayNotas() {
    return this.notasForm.controls;
  }
  //Contactos
  public contactosForm = new FormArray([]);
  get arrayContactos() {
    return this.contactosForm.controls;
  }
  get contactosOrdenados() {
    return [...this.contactosForm.controls]
      .map((ctrl, i) => ({ ctrl, i }))
      .sort((a, b) => (a.ctrl.value.orden ?? 0) - (b.ctrl.value.orden ?? 0));
  }
  // Excepciones (buffer para creación)
  public excepcionesBuffer: { fechaDesde: string; fechaHasta: string }[] = [];

  // Resultados parciales de una creación que falló a mitad de camino: se
  // reusan en el reintento para no dejar ubicaciones/alarmas huérfanas.
  private ubicacionCreada?: IUbicacion;
  private alarmaCreada?: IDispositivoAlarma;
  // Guard de reentrada: los botones de guardar no se deshabilitan solos
  public guardando = false;

  get idCliente() {
    return this.formBasica.get('idCliente')?.value;
  }

  /** Última miga: el formulario no tiene otro nombre que su acción. */
  get tituloMiga(): string {
    return this.id ? 'Editar alarma' : 'Nueva alarma';
  }

  public volver(): void {
    this.origen.volver('/main/alarmas/alarmasDomiciliarias');
  }

  //Crears
  public crearCamara() {
    this.paramsService.setParams({
      desdeAlarma: true,
      idCliente: this.formBasica.value.idCliente,
    });
    const dialog = this.dialog.open(CrearEditarCamaraComponent);
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        const camaras = this.formCamaras?.value?.idsCamaras || [];
        camaras.push(res);
        this.formCamaras.patchValue({ idsCamaras: camaras });
      }
    });
  }

  //Listars
  public async listarCamaras(): Promise<void> {
    // Sin módulo de cámaras el endpoint /camaras responde 403
    if (!this.permisosEntidades.verModuloCamaras()) {
      this.camaras = [];
      return;
    }
    return new Promise<void>((resolve) => {
      // Determinar el idCliente de acuerdo al estado (creando o editando)
      const idClienteDeAlarma = this.formBasica?.value?.idCliente;
      const query: IQueryParam = {
        filter: JSON.stringify({ idCliente: idClienteDeAlarma }),
        includeChildren: true,
      };
      this.camaras$ = this.lista2.camaras(query).subscribe({
        next: (data) => {
          this.camaras = data.datos;
          // Si esta editando
          if (this.id && this.alarmaEditar?.idsCamaras?.length > 0) {
            this.camarasDeAlarma = this.camaras.filter((c) =>
              this.alarmaEditar.idsCamaras.includes(c._id),
            );
          }
          resolve();
        },
        error: (error) => {
          console.error('Error al listar cámaras', error);
          this.camaras = [];
          resolve();
        },
      });
    });
  }

  public async listarNotasYContactos(): Promise<void> {
    // Si se está creando (no hay alarma existente) no hay notas/contactos que
    // listar. Sin este guard, el filtro quedaría vacío y traería TODAS las
    // notas (incluidas las no asignadas).
    if (!this.id) {
      return;
    }
    const filter: IFilter<INota> = {
      idAsignado: this.id,
    };
    // includeChildren: las notas/contactos se guardan con el idCliente de la
    // alarma. Si el usuario opera desde un cliente ancestro, sin este flag el
    // backend solo matchea idCliente === permiso.idCliente y las oculta.
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      includeChildren: true,
      sort: 'orden',
    };
    this.notas$?.unsubscribe();
    this.notas$ = this.lista2.notas(query).subscribe((data) => {
      this.notas = data.datos;
      // Los FormArray se rearman desde cero: sin el clear, cada emisión
      // agregaría otra copia de todas las notas y contactos.
      this.notasForm.clear();
      this.contactosForm.clear();
      data.datos.forEach((nota) => {
        //Revisar de no borrar una que ya exista
        if (nota.tipo === 'Contacto') {
          const contactos = new FormGroup({
            nuevo: new FormControl(false),
            id: new FormControl(nota._id),
            orden: new FormControl(nota.orden, [
              Validators.required,
              Validators.pattern('^[0-9]*$'), // Solo números
            ]),
            tipo: new FormControl(nota.tipo),
            permanente: new FormControl(
              nota.permanente === false ? false : true,
            ),
            vigenciaDesde: new FormControl(nota.vigenciaDesde),
            vigenciaHasta: new FormControl(nota.vigenciaHasta),
            inhabilitadoDesde: new FormControl(nota.inhabilitadoDesde),
            inhabilitadoHasta: new FormControl(nota.inhabilitadoHasta),
            idCategoriaEvento: new FormControl(nota.idCategoriaEvento),
            informacion: new FormGroup({
              contacto: new FormControl(nota.informacion?.contacto),
              telefono: new FormControl(nota.informacion?.telefono),
              interno: new FormControl(nota.informacion?.interno),
              email: new FormControl(nota.informacion?.email),
              particion: new FormControl(nota.informacion?.particion, [
                Validators.pattern('^[0-9]*$'), // Solo números
              ]),
              palabraSeguridadNormal: new FormControl(
                nota.informacion?.palabraSeguridadNormal,
              ),
              palabraSeguridadEmergencia: new FormControl(
                nota.informacion?.palabraSeguridadEmergencia,
              ),
              nota: new FormControl(nota.informacion?.nota),
              numeroUsuarioAlarma: new FormControl(
                nota.informacion?.numeroUsuarioAlarma,
              ),
            }),
          });
          this.contactosForm.push(contactos);
        } else if (nota.tipo === 'Nota') {
          const notas = new FormGroup({
            nuevo: new FormControl(false),
            id: new FormControl(nota._id),
            orden: new FormControl(nota.orden, [
              Validators.required,
              Validators.pattern('^[0-9]*$'), // Solo números
            ]),
            tipo: new FormControl(nota.tipo),
            permanente: new FormControl(
              nota.permanente === false ? false : true,
            ),
            vigenciaDesde: new FormControl(nota.vigenciaDesde),
            vigenciaHasta: new FormControl(nota.vigenciaHasta),
            inhabilitadoDesde: new FormControl(nota.inhabilitadoDesde),
            inhabilitadoHasta: new FormControl(nota.inhabilitadoHasta),
            idCategoriaEvento: new FormControl(nota.idCategoriaEvento),
            informacion: new FormGroup({
              contacto: new FormControl(nota.informacion?.contacto),
              telefono: new FormControl(nota.informacion?.telefono),
              interno: new FormControl(nota.informacion?.interno),
              email: new FormControl(nota.informacion?.email),
              particion: new FormControl(nota.informacion?.particion, [
                Validators.pattern('^[0-9]*$'), // Solo números
              ]),
              palabraSeguridadNormal: new FormControl(
                nota.informacion?.palabraSeguridadNormal,
              ),
              palabraSeguridadEmergencia: new FormControl(
                nota.informacion?.palabraSeguridadEmergencia,
              ),
              nota: new FormControl(nota.informacion?.nota),
              numeroUsuarioAlarma: new FormControl(
                nota.informacion?.numeroUsuarioAlarma,
              ),
            }),
          });
          this.notasForm.push(notas);
        }
      });
    });
  }
  private async listarServicios(): Promise<void> {
    return new Promise<void>((resolve) => {
      const query: IQueryParam = {
        sort: 'nombre',
        select: 'nombre icono',
      };
      this.servicios$?.unsubscribe();
      this.servicios$ = this.lista2
        .serviciosContratados(query)
        .subscribe((data) => {
          this.servicios = data.datos;
          resolve();
        });
    });
  }

  private async listarTodo() {
    await Promise.all([
      this.listarCamaras(),
      this.listarNotasYContactos(),
      this.listarServicios(),
    ]);
  }

  // Disclaimer: Si esto tiene errores es culpa de Fran, yo solamente lo acomodé en funciones mas atómicas porque daba mas cancer que el asbesto.
  // Guardar
  public async guardarAlarma() {
    // Los botones quedan clickeables mientras se guarda: sin este guard, un
    // doble click dispara dos guardados completos (alarma y notas duplicadas).
    if (this.guardando) {
      return;
    }
    // Solo ejecuta si los formularios son válidos
    if (
      !this.formBasica.valid ||
      !this.formDetallada.valid ||
      !this.formUbicacion.valid
    ) {
      this.helper.notifWarn(
        'Completá todos los datos requeridos antes de guardar.',
      );
      return;
    }

    if (!(await this.chequeo.puedeGuardar())) {
      this.helper.notifError(`${this.chequeo.textoRepetida} Elegí otra.`);
      return;
    }

    this.guardando = true;
    try {
      if (!this.alarmaEditar) {
        //Si esta creando
        const created = await this.create();
        if (created) {
          this.helper.notifSuccess('Alarma creada con éxito.');
          this.volver();
        }
      } else {
        //Si esta editando
        const updated = await this.update();
        if (updated) {
          this.helper.notifSuccess('Alarma actualizada con éxito.');
          this.volver();
        }
      }
    } finally {
      this.guardando = false;
    }
  }

  // Funciones helper para mostrar nombres en la vista
  public nombreCamara(idCamara: string) {
    return this.camarasDeAlarma?.find((c) => c._id === idCamara)
      ?.identificacion;
  }
  public nombreCanalCamara(id: string, canal: string) {
    const camara = this.camaras?.find((c) => c._id === id);
    if (camara)
      return camara.canales.length > 0
        ? camara.canales.find((c) => c.numero == canal)?.nombre
        : null;
    return null;
  }

  // Funciones helper para formatear horarios
  public formatearDias(dias: string[]): string {
    if (!dias || dias.length === 0) return '';

    const todosDias = [
      'Lunes',
      'Martes',
      'Miercoles',
      'Jueves',
      'Viernes',
      'Sabado',
      'Domingo',
    ];
    const diasLaborales = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes'];

    // Verificar si son todos los días
    if (dias.length === 7 && todosDias.every((dia) => dias.includes(dia))) {
      return 'Todos los días';
    }

    // Verificar si son Lunes a Viernes
    if (dias.length === 5 && diasLaborales.every((dia) => dias.includes(dia))) {
      return 'Lunes a Viernes';
    }

    // Formatear cada día con tilde y unir con comas
    return dias.map((dia) => this.getNombreDiaConTilde(dia as Dia)).join(', ');
  }

  public getNombreDiaConTilde(dia: Dia): string {
    // Mostrar con tilde solo para visualización, sin afectar las comparaciones
    if (dia === 'Miercoles') return 'Miércoles';
    if (dia === 'Sabado') return 'Sábado';
    return dia;
  }

  public formatearHora(hora: string): string {
    if (!hora) return '';
    return hora;
  }

  public formatearTolerancia(
    toleranciaAntes: number,
    toleranciaDespues: number,
  ): string {
    if (!toleranciaAntes && !toleranciaDespues) return 'Sin tolerancia';
    const antes = toleranciaAntes ? `${toleranciaAntes} min antes` : '';
    const despues = toleranciaDespues ? `${toleranciaDespues} min después` : '';
    if (antes && despues) return `${antes}, ${despues}`;
    return antes || despues;
  }

  public getHorariosAperturas() {
    const ordenDias = [
      'Lunes',
      'Martes',
      'Miercoles',
      'Jueves',
      'Viernes',
      'Sabado',
      'Domingo',
    ];

    return this.horariosForm.controls
      .map((control, index) => ({ control, index }))
      .filter((item) => item.control.value?.tipo === 'Apertura')
      .sort((a, b) => {
        const diasA = a.control.value?.dias || [];
        const diasB = b.control.value?.dias || [];

        // Obtener el primer día de cada horario según el orden de la semana
        const primerDiaA =
          diasA.length > 0
            ? Math.min(...diasA.map((dia: string) => ordenDias.indexOf(dia)))
            : 999;
        const primerDiaB =
          diasB.length > 0
            ? Math.min(...diasB.map((dia: string) => ordenDias.indexOf(dia)))
            : 999;

        return primerDiaA - primerDiaB;
      });
  }

  public getHorariosCierres() {
    const ordenDias = [
      'Lunes',
      'Martes',
      'Miercoles',
      'Jueves',
      'Viernes',
      'Sabado',
      'Domingo',
    ];

    return this.horariosForm.controls
      .map((control, index) => ({ control, index }))
      .filter((item) => item.control.value?.tipo === 'Cierre')
      .sort((a, b) => {
        const diasA = a.control.value?.dias || [];
        const diasB = b.control.value?.dias || [];

        // Obtener el primer día de cada horario según el orden de la semana
        const primerDiaA =
          diasA.length > 0
            ? Math.min(...diasA.map((dia: string) => ordenDias.indexOf(dia)))
            : 999;
        const primerDiaB =
          diasB.length > 0
            ? Math.min(...diasB.map((dia: string) => ordenDias.indexOf(dia)))
            : 999;

        return primerDiaA - primerDiaB;
      });
  }

  /**
   * Convierte una hora en formato HH:mm a minutos desde las 00:00
   */
  private convertirHoraAMinutos(hora: string): number {
    if (!hora) return 0;
    const [horas, minutos] = hora.split(':').map(Number);
    return horas * 60 + minutos;
  }

  private addCamaraFormGroup(camara?: ICamaraAlarma) {
    return new FormGroup({
      idCamara: new FormControl(camara?.idCamara, [Validators.required]),
      particion: new FormControl(camara?.particion, [Validators.required]),
      zona: new FormControl(camara?.zona, [Validators.required]),
      canal: new FormControl(camara?.canal, [Validators.required]),
    });
  }
  public editCamaraAlarma(i: number) {
    const valor = this.camarasForm.value[i];
    this.camarasForm.removeAt(i);
    if (!valor) return;
    const data = {
      camarasDeAlarma: this.camarasDeAlarma,
      infoEditar: valor,
    };
    const dialog = this.formularios.abrir(AgregarCanalCamaraCompletoComponent, {
      tamano: 'mediano',
      data,
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.camarasForm.push(this.addCamaraFormGroup(res));
      }
    });
  }
  public deleteCamaraAlarma(i: number) {
    this.camarasForm.removeAt(i);
  }
  public addCamara() {
    const data = {
      camarasDeAlarma: this.camarasDeAlarma,
    };
    const dialog = this.formularios.abrir(AgregarCanalCamaraCompletoComponent, {
      tamano: 'mediano',
      data,
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.camarasForm.push(this.addCamaraFormGroup(res));
      }
    });
  }

  // Funciones para Control Horario
  public addHorario() {
    const dialog = this.formularios.abrir(AgregarHorarioCompletoComponent, {
      tamano: 'mediano',
      data: { tipoInicial: 'Apertura' },
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.horariosForm.push(res);
        // Activar automáticamente el control horario si se agrega el primer horario
        if (this.horariosForm.controls.length === 1) {
          this.formControlHorario.get('activo')?.setValue(true);
        }
      }
    });
  }

  public editHorario(i: number) {
    const horario = this.horariosForm.value[i];
    const data = { horarioEditar: horario };
    const dialog = this.formularios.abrir(AgregarHorarioCompletoComponent, {
      tamano: 'mediano',
      data,
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.horariosForm.removeAt(i);
        this.horariosForm.push(res);
      }
    });
  }

  public deleteHorario(i: number) {
    this.horariosForm.removeAt(i);
  }

  public addNota_Contacto() {
    const data = {
      tipo: 'Contacto',
      nuevo: true,
    };
    const dialog = this.formularios.abrir(CrearNotaAlarmaCompletoComponent, {
      tamano: 'mediano',
      data,
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.contactosForm.push(res);
      }
    });
  }

  public verDetallesContacto(i: number) {
    const valor = this.contactosForm.at(i) as FormGroup;
    this.formularios.abrir(DetallesNotaComponent, {
      tamano: 'chico',
      data: { ...valor.value.informacion, idNota: valor.value.id },
      cerrarAfuera: true,
    });
  }

  public editNota_Contacto(i: number) {
    const valor = this.contactosForm.at(i) as FormGroup;
    const data = {
      form: valor,
      tipo: 'Contacto',
      nuevo: valor.value.nuevo,
    };
    const dialog = this.formularios.abrir(CrearNotaAlarmaCompletoComponent, {
      tamano: 'mediano',
      data,
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.contactosForm.setControl(i, res);
      }
    });
  }
  public addNota_Nota() {
    const data = {
      tipo: 'Nota',
      nuevo: true,
    };
    const dialog = this.formularios.abrir(CrearNotaAlarmaCompletoComponent, {
      tamano: 'mediano',
      data,
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.notasForm.push(res);
      }
    });
  }

  public editNota_Nota(i: number) {
    const valor = this.notasForm.at(i) as FormGroup;
    const data = {
      form: valor,
      tipo: 'Nota',
      nuevo: valor.value.nuevo,
    };
    const dialog = this.formularios.abrir(CrearNotaAlarmaCompletoComponent, {
      tamano: 'mediano',
      data,
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.notasForm.setControl(i, res);
      }
    });
  }

  public async deleteNota_Contacto(i: number) {
    const data = this.contactosForm.value[i];
    this.contactosForm.removeAt(i);
    if (!data.nuevo) {
      await this.notasService.delete(data.id);
    }
  }
  public async deleteNota_Nota(i: number) {
    const data = this.notasForm.value[i];
    this.notasForm.removeAt(i);
    if (!data.nuevo) {
      await this.notasService.delete(data.id);
    }
  }

  /// Drag and Drop INFOZONA
  public dropInfoZonas(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.arrayZonas, event.previousIndex, event.currentIndex);
    this.formInfoZonas.patchValue(this.arrayZonas);
  }
  /// Drag and Drop CONTACTOS
  public dropContactos(event: CdkDragDrop<string[]>): void {
    moveItemInArray(
      this.arrayContactos,
      event.previousIndex,
      event.currentIndex,
    );
    this.contactosForm.patchValue(this.arrayContactos);
  }
  /// Drag and Drop NOTAS
  public dropNotas(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.arrayNotas, event.previousIndex, event.currentIndex);
    this.notasForm.patchValue(this.arrayNotas);
  }
  /// Drag and Drop CAMARAS
  public drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.arrayCamaras, event.previousIndex, event.currentIndex);
    this.camarasForm.patchValue(this.arrayCamaras);
  }
  /// Drag and Drop HORARIOS
  public dropHorarios(event: CdkDragDrop<string[]>): void {
    moveItemInArray(
      this.horariosForm.controls,
      event.previousIndex,
      event.currentIndex,
    );
    this.horariosForm.updateValueAndValidity();
  }

  public verVisualizadorHorario(): void {
    const data = {
      horarios: this.horariosForm.value,
    };
    this.formularios.abrir(VisualizadorHorarioComponent, {
      tamano: 'grande',
      data,
      cerrarAfuera: true,
    });
  }

  public onClienteChange(cliente: ICliente) {
    // Resetea warnings de duplicados
    this.warnNumeroAbonado = false;
    this.warnNroDeSistema = false;
    // El mensaje de identificación repetida aclara el cliente: revalidar.
    this.chequeo.revalidar();

    // Resetea el form
    this.formBasica
      ?.get('idsClientesQuePuedenAtenderEventosTecnicos')
      ?.setValue(null);

    // Filtrar horarios: conservar solo miCliente si estaba seleccionado
    const propioId = this.miCliente?._id;
    for (const ctrl of [
      'configHorariosAtencion',
      'configHorariosAtencionTecnica',
    ]) {
      const current = this.formBasica?.get(ctrl)?.value;
      if (current?.length) {
        const filtered = current.filter((c: any) => c.idCliente === propioId);
        this.formBasica
          ?.get(ctrl)
          ?.patchValue(filtered.length ? filtered : null);
      }
    }

    // Carga las cosas del nuevo cliente
    if (cliente) {
      this.listarCamaras();
    } else {
      this.camaras = [];
    }
  }

  public patchDireccion(domicilio: string) {
    this.formUbicacion.patchValue({ domicilio });
  }
  ///
  public deleteInfoZona(i: number) {
    this.formInfoZonas.removeAt(i);
  }

  public addInfoZona() {
    const dialog = this.formularios.abrir(AgregarInfoZonaCompletoComponent, {
      tamano: 'mediano',
      data: { zonasExistentes: this.formInfoZonas.value },
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.formInfoZonas.push(res);
      }
    });
  }

  public editInfoZona(i: number) {
    const particionZona = this.formInfoZonas.value[i];
    const data = {
      infoEditar: particionZona,
      zonasExistentes: this.formInfoZonas.value,
    };
    const dialog = this.formularios.abrir(AgregarInfoZonaCompletoComponent, {
      tamano: 'mediano',
      data,
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        // setControl y no removeAt+push: reemplazar en el lugar mantiene el
        // orden de la lista (antes la zona editada saltaba al final).
        this.formInfoZonas.setControl(i, res);
      }
    });
  }

  private addInfoZonaFormGroup(infozona?: IParticionZona) {
    const sensoresArray = new FormArray<FormGroup>([]);
    infozona?.sensores?.forEach((sensor: ISensorPorZona) => {
      sensoresArray.push(
        new FormGroup({
          tipo: new FormControl(sensor.tipo, [Validators.required]),
          marca: new FormControl(sensor.marca, [Validators.required]),
          modelo: new FormControl(sensor.modelo, [Validators.required]),
        }),
      );
    });
    return new FormGroup({
      nombre: new FormControl(infozona?.nombre, [Validators.required]),
      particion: new FormControl(infozona?.particion, [Validators.required]),
      zona: new FormControl(infozona?.zona, [Validators.required]),
      modo: new FormControl(infozona?.modo, [Validators.required]),
      sensores: sensoresArray,
    });
  }

  private addHorarioFormGroup(horario?: IControlHorarioDetalles) {
    return new FormGroup({
      tipo: new FormControl(horario?.tipo, [Validators.required]),
      dias: new FormControl(horario?.dias || [], [Validators.required]),
      hora: new FormControl(horario?.hora, [Validators.required]),
      toleranciaAntes: new FormControl(horario?.toleranciaAntes || 0, [
        Validators.required,
        Validators.min(0),
      ]),
      toleranciaDespues: new FormControl(horario?.toleranciaDespues || 0, [
        Validators.required,
        Validators.min(0),
      ]),
      particion: new FormControl(horario?.particion, [
        Validators.pattern('^[0-9]*$'),
      ]),
    });
  }
  ///
  public asignarCamarasDeAlarma(camaras: ICamara[]) {
    this.camarasDeAlarma = camaras;
  }
  //
  public async validarExistencia(event: FocusEvent) {
    const valor = (event.target as HTMLInputElement).value
      ?.trim()
      .toUpperCase();
    if (!valor) {
      this.warnNumeroAbonado = false;
      return;
    }
    const idCliente = this.idCliente;
    if (!idCliente) {
      this.warnNumeroAbonado = false;
      return;
    }
    try {
      this.warnNumeroAbonado = await this.alarmasService.hayNumeroAbonado(
        valor,
        idCliente,
        this.id ?? undefined,
      );
    } catch {
      this.warnNumeroAbonado = false;
    }
  }

  public async validarNroDeSistema(event: FocusEvent) {
    const valor = (event.target as HTMLInputElement).value?.trim();
    if (!valor) {
      this.warnNroDeSistema = false;
      return;
    }
    const idCliente = this.idCliente;
    if (!idCliente) {
      this.warnNroDeSistema = false;
      return;
    }
    try {
      this.warnNroDeSistema = await this.alarmasService.hayNroDeSistema(
        valor,
        idCliente,
        this.id ?? undefined,
      );
    } catch {
      this.warnNroDeSistema = false;
    }
  }

  /**
   * Arma comunicadores[] a partir de la lista uniforme (comunicadoresForm).
   * Si se pasan `existentes` (edición), conserva por ítem los campos que
   * este form no edita (ultimaConexion, fechaUltimaComunicacion, modelo) —
   * el array se reemplaza entero en el update, así que no propagarlos acá
   * los borra en el backend.
   */
  private buildComunicadores(
    existentes?: IComunicadorAlarma[],
  ): IComunicadorAlarma[] {
    return (this.comunicadoresForm?.value ?? [])
      .map((c: IComunicadorAlarma, i: number) => ({
        ...existentes?.[i],
        idComunicador: c.idComunicador,
        passwordComunicador: c.passwordComunicador,
      }))
      .filter((c: IComunicadorAlarma) => !!c.idComunicador);
  }

  /** Un slot de SIM se persiste si tiene ALGÚN dato, no solo iccid. */
  private simTieneDatos(sim: any): boolean {
    if (!sim) return false;
    return ['iccid', 'numero', 'operador', 'apn', 'usuario', 'password'].some(
      (k) => !!sim[k],
    );
  }

  /**
   * SIM como entidad aparte: por cada slot con datos, persiste la SIM
   * (POST /sims/upsert) y setea idSim1/idSim2 en la alarma. El `_id` del grupo
   * (la SIM ya vinculada o la elegida en el selector de disponibles) hace que
   * sin iccid se actualice esa SIM en vez de crear otra.
   */
  private async aplicarSims(data: ICreateDispositivoAlarma) {
    if (this.simTieneDatos(this.formSim1.value)) {
      const s = await this.simsService.upsert(this.payloadSim(this.formSim1));
      data.idSim1 = s._id;
    } else {
      data.idSim1 = null;
    }
    if (this.simTieneDatos(this.formSim2.value)) {
      const s = await this.simsService.upsert(this.payloadSim(this.formSim2));
      data.idSim2 = s._id;
    } else {
      (data as any).idSim2 = null;
    }
  }

  /** Datos de la SIM del grupo; sin `_id` (SIM nueva) no se manda la clave. */
  private payloadSim(form: FormGroup) {
    const { _id, ...datos } = form.value;
    return _id ? { ...datos, _id } : datos;
  }

  // Funciones de crear
  private async createUbicacion() {
    try {
      const ubicacionNueva: ICreateUbicacion = {
        idCliente: this.formBasica.value?.idCliente,
        direccion: this.formUbicacion.value?.domicilio,
        geojson: {
          type: 'Point',
          coordinates: this.formUbicacion.value?.geojson.coordinates,
        },
        identificacion: this.formUbicacion.value?.domicilio,
        categoria: 'Domicilio',
      };
      return await this.ubicacionService.create(ubicacionNueva);
    } catch (error) {
      this.helper.notifError(error);
      console.error(error);
      return null;
    }
  }
  private async createAlarma(ubicacion: IUbicacion) {
    try {
      const idsAtencion = (this.formBasica.value?.configHorariosAtencion ?? [])
        .map((c: any) => c.idCliente)
        .filter(Boolean) as string[];
      const idsTecnicos = (
        this.formBasica.value?.configHorariosAtencionTecnica ?? []
      )
        .map((c: any) => c.idCliente)
        .filter(Boolean) as string[];
      const dataAlarma: ICreateDispositivoAlarma = {
        nombre: this.formBasica.value?.nombre,
        numeroAbonado: this.formBasica.value?.numeroAbonado,
        idCliente: this.formBasica.value?.idCliente,
        idsClientesQuePuedenAtender: idsAtencion,
        idsClientesQuePuedenAtenderEventosTecnicos: idsTecnicos.length
          ? idsTecnicos
          : null,
        configHorariosAtencion: this.formBasica.value?.configHorariosAtencion,
        configHorariosAtencionTecnica:
          this.formBasica.value?.configHorariosAtencionTecnica,
        puedeSolicitarServicioTecnico:
          this.formBasica.value?.puedeSolicitarServicioTecnico,
        idUnicoComunicador: this.formDetallada.value?.idUnicoComunicador,
        comunicadores: this.buildComunicadores(),
        nroDeSistema: this.formDetallada.value?.nroDeSistema,
        idModelo: this.formDetallada.value?.idModelo,
        frecReporte: this.formDetallada.value?.frecReporte,
        credencialesAlarma: this.buildCredencialesAlarma(),
        infoZonas: this.formInfoZonas.value,
        idsCamaras: this.formCamaras.value?.idsCamaras,
        camarasPorZona: this.formCamaras.value?.camaras,
        idDomicilio: ubicacion._id,
        idServiciosContratados: this.formBasica.value?.idServiciosContratados,
        controlHorario: {
          activo: this.formControlHorario.value?.activo ?? false,
          ignorarArmadosFueraDeHorario:
            this.formControlHorario.value?.ignorarArmadosFueraDeHorario ??
            false,
          ignorarDesarmadosFueraDeHorario:
            this.formControlHorario.value?.ignorarDesarmadosFueraDeHorario ??
            false,
          horarios: this.horariosForm.value,
        },
      };
      await this.aplicarSims(dataAlarma);
      return await this.alarmasService.create(dataAlarma);
    } catch (error) {
      this.helper.notifError(error);
      console.error(error);
      return null;
    }
  }
  // Marca en el form las notas/contactos que el backend acabó de crear: les
  // setea el _id y baja el flag 'nuevo'. Sin esto, un guardado que falla
  // después de crearlas deja los controles intactos y el reintento las vuelve
  // a crear (duplicados por cada intento). La respuesta de /notas/many
  // conserva el orden del array enviado, así que el mapeo por índice es válido.
  private marcarComoCreadas(controles: FormGroup[], creadas: INota[]): void {
    controles.forEach((control, i) => {
      const creada = creadas?.[i];
      if (!creada?._id) return;
      control.get('nuevo')?.setValue(false);
      if (control.get('id')) {
        control.get('id').setValue(creada._id);
      } else {
        control.addControl('id', new FormControl(creada._id));
      }
    });
  }

  private async createNotas(alarma: IDispositivoAlarma) {
    try {
      // Al crear la alarma todas las notas del form son nuevas: se asignan a
      // la alarma recién creada. Sin idAsignado quedarían huérfanas.
      // El idCliente debe ser el de la alarma, no el del usuario que la crea:
      // si no se envía, el backend usa el del permiso (cliente del usuario).
      // Se excluyen las que ya tienen id: son las creadas en un intento previo
      // que falló más adelante, y volver a mandarlas las duplicaría.
      const pendientes = (this.notasForm.controls as FormGroup[]).filter(
        (control) => !control.value?.id,
      );
      const notasData: ICreateNota[] = pendientes.map((control) => ({
        ...control.value,
        idAsignado: alarma._id,
        idCliente: alarma.idCliente ?? this.idCliente,
      }));
      if (notasData.length === 0) {
        return [];
      }
      const creadas = await this.notasService.createMany(notasData);
      this.marcarComoCreadas(pendientes, creadas);
      return creadas;
    } catch (error) {
      this.helper.notifWarn('Error al crear notas');
      console.error(error);
      return null;
    }
  }
  private async createContactos(alarma: IDispositivoAlarma) {
    try {
      // Al crear la alarma todos los contactos del form son nuevos: se asignan
      // a la alarma recién creada. Sin idAsignado quedarían huérfanos.
      // El idCliente debe ser el de la alarma, no el del usuario que la crea:
      // si no se envía, el backend usa el del permiso (cliente del usuario).
      // Igual que en las notas, los que ya tienen id vienen de un intento
      // previo y no se reenvían.
      const pendientes = (this.contactosForm.controls as FormGroup[]).filter(
        (control) => !control.value?.id,
      );
      const contactosData: ICreateNota[] = pendientes.map((control) => ({
        ...control.value,
        idAsignado: alarma._id,
        idCliente: alarma.idCliente ?? this.idCliente,
      }));
      if (contactosData.length === 0) {
        return [];
      }
      const creados = await this.notasService.createMany(contactosData);
      this.marcarComoCreadas(pendientes, creados);
      return creados;
    } catch (error) {
      this.helper.notifWarn('Error al crear contactos');
      console.error(error);
      return null;
    }
  }

  private async createExcepciones(alarma: IDispositivoAlarma) {
    if (this.excepcionesBuffer.length === 0) return [];
    // Secuencial y sacando cada excepción del buffer apenas se crea: si una
    // falla, el reintento solo manda las que quedaron pendientes en vez de
    // duplicar las que ya entraron.
    const creadas: IExcepcion[] = [];
    try {
      while (this.excepcionesBuffer.length > 0) {
        const exc = this.excepcionesBuffer[0];
        creadas.push(
          await this.excepcionesService.create({
            idEntidad: alarma._id,
            tipoEntidad: 'Alarma',
            tipoExcepcion: 'Control Horario',
            fechaDesde: exc.fechaDesde,
            fechaHasta: exc.fechaHasta,
          }),
        );
        this.excepcionesBuffer.shift();
      }
      return creadas;
    } catch (error) {
      this.helper.notifWarn('Error al crear excepciones');
      console.error(error);
      return null;
    }
  }

  private async create() {
    // Si un intento anterior falló en un paso posterior, la ubicación y la
    // alarma ya existen: se reusan en vez de crear otro par de registros
    // huérfanos en cada reintento.
    const ubicacion = this.ubicacionCreada ?? (await this.createUbicacion());
    if (!ubicacion) {
      return null;
    }
    this.ubicacionCreada = ubicacion;

    const alarma = this.alarmaCreada ?? (await this.createAlarma(ubicacion));
    if (!alarma) {
      return null;
    }
    this.alarmaCreada = alarma;
    // Las notas/contactos nuevos se cuelgan de esta alarma en el reintento
    this.id ??= alarma._id;

    const [notas, contactos, excepciones] = await Promise.all([
      this.createNotas(alarma),
      this.createContactos(alarma),
      this.createExcepciones(alarma),
    ]);

    if (!notas || !contactos || !excepciones) {
      return null;
    }
    return alarma;
  }

  // Funciones de actualizar
  private async upsertUbicacion() {
    // Si la alarma no tiene domicilio (legacy o creación parcial), se crea uno nuevo
    if (!this.alarmaEditar?.domicilio?._id) {
      return this.createUbicacion();
    }
    try {
      const ubicacionActualizada: IUpdateUbicacion = {
        idCliente: this.formBasica.value?.idCliente,
        direccion: this.formUbicacion.value?.domicilio,
        geojson: {
          type: 'Point',
          coordinates: this.formUbicacion.value?.geojson.coordinates,
        },
        identificacion: this.formUbicacion.value?.domicilio,
        categoria: 'Domicilio',
      };
      return await this.ubicacionService.update(
        this.alarmaEditar.domicilio._id,
        ubicacionActualizada,
      );
    } catch (error) {
      this.helper.notifWarn('No pudo actualizarse la ubicación');
      console.error(error);
      return null;
    }
  }
  private async updateNotas() {
    try {
      const notasData: ICreateNota[] = [];
      const nuevosControles: FormGroup[] = [];
      const updatePromises: Promise<INota>[] = [];

      (this.notasForm.controls as FormGroup[]).map((control) => {
        const n = control.value;
        // Con id ya existe en la base aunque el flag 'nuevo' siga en true
        // (creada en un intento anterior): va por update, no por create.
        if (n.nuevo && !n.id) {
          // Crear nuevas notas con el cliente de la alarma (si no se envía, el
          // backend usa el del permiso = cliente del usuario logueado)
          n.idAsignado = this.id;
          n.idCliente = this.idCliente;
          notasData.push(n);
          nuevosControles.push(control);
        } else if (n.id) {
          // Actualizar notas existentes. Se manda el idCliente de la alarma
          // para sanear las notas que quedaron con el del usuario que las
          // creó: el backend descarta el campo si no cambió, y si cambió
          // gestion-datos-go recalcula idsAncestros con el cliente correcto.
          const updateData: any = {
            idCliente: this.idCliente,
            orden: n.orden,
            permanente: n.permanente,
            vigenciaDesde: n.vigenciaDesde,
            vigenciaHasta: n.vigenciaHasta,
            inhabilitadoDesde: n.inhabilitadoDesde,
            inhabilitadoHasta: n.inhabilitadoHasta,
            idCategoriaEvento: n.idCategoriaEvento,
            informacion: n.informacion,
          };
          updatePromises.push(this.notasService.update(n.id, updateData));
        }
      });

      // Ejecutar actualizaciones y creaciones en paralelo
      const [creadas, ...actualizadas] = await Promise.all([
        notasData.length > 0
          ? this.notasService.createMany(notasData)
          : Promise.resolve([] as INota[]),
        ...updatePromises,
      ]);
      // Sella las recién creadas para que un reintento no las duplique
      this.marcarComoCreadas(nuevosControles, creadas as INota[]);

      return [creadas, ...actualizadas].flat();
    } catch (error) {
      this.helper.notifWarn('Error al actualizar notas');
      console.error(error);
      return null;
    }
  }
  private async updateContactos() {
    try {
      const contactosData: ICreateNota[] = [];
      const nuevosControles: FormGroup[] = [];
      const updatePromises: Promise<INota>[] = [];

      (this.contactosForm.controls as FormGroup[]).map((control) => {
        const c = control.value;
        // Con id ya existe en la base aunque el flag 'nuevo' siga en true
        // (creado en un intento anterior): va por update, no por create.
        if (c.nuevo && !c.id) {
          // Crear nuevos contactos con el cliente de la alarma (si no se envía,
          // el backend usa el del permiso = cliente del usuario logueado)
          c.idAsignado = this.id;
          c.idCliente = this.idCliente;
          contactosData.push(c);
          nuevosControles.push(control);
        } else if (c.id) {
          // Actualizar contactos existentes. Igual que en las notas, se manda
          // el idCliente de la alarma para sanear los que quedaron con el del
          // usuario que los creó.
          const updateData: any = {
            idCliente: this.idCliente,
            orden: c.orden,
            permanente: c.permanente,
            vigenciaDesde: c.vigenciaDesde,
            vigenciaHasta: c.vigenciaHasta,
            inhabilitadoDesde: c.inhabilitadoDesde,
            inhabilitadoHasta: c.inhabilitadoHasta,
            idCategoriaEvento: c.idCategoriaEvento,
            informacion: c.informacion,
          };
          updatePromises.push(this.notasService.update(c.id, updateData));
        }
      });

      // Ejecutar actualizaciones y creaciones en paralelo
      const [creados, ...actualizados] = await Promise.all([
        contactosData.length > 0
          ? this.notasService.createMany(contactosData)
          : Promise.resolve([] as INota[]),
        ...updatePromises,
      ]);
      // Sella los recién creados para que un reintento no los duplique
      this.marcarComoCreadas(nuevosControles, creados as INota[]);

      return [creados, ...actualizados].flat();
    } catch (error) {
      this.helper.notifWarn('Error al actualizar contactos');
      console.error(error);
      return null;
    }
  }
  private async updateAlarma(idDomicilio: string) {
    try {
      const idsAtencion = (this.formBasica.value?.configHorariosAtencion ?? [])
        .map((c: any) => c.idCliente)
        .filter(Boolean) as string[];
      const idsTecnicos = (
        this.formBasica.value?.configHorariosAtencionTecnica ?? []
      )
        .map((c: any) => c.idCliente)
        .filter(Boolean) as string[];
      const dataAlarma: ICreateDispositivoAlarma = {
        nombre: this.formBasica.value?.nombre,
        numeroAbonado: this.formBasica.value?.numeroAbonado,
        idCliente: this.formBasica.value?.idCliente,
        idsClientesQuePuedenAtender: idsAtencion,
        idsClientesQuePuedenAtenderEventosTecnicos: idsTecnicos.length
          ? idsTecnicos
          : null,
        configHorariosAtencion: this.formBasica.value?.configHorariosAtencion,
        configHorariosAtencionTecnica:
          this.formBasica.value?.configHorariosAtencionTecnica,
        puedeSolicitarServicioTecnico:
          this.formBasica.value?.puedeSolicitarServicioTecnico,
        idServiciosContratados: this.formBasica.value?.idServiciosContratados,
        idUnicoComunicador: this.formDetallada.value?.idUnicoComunicador,
        comunicadores: this.buildComunicadores(
          this.alarmaEditar?.comunicadores,
        ),
        idModelo: this.formDetallada.value?.idModelo,
        frecReporte: this.formDetallada.value?.frecReporte,
        credencialesAlarma: this.buildCredencialesAlarma(),
        nroDeSistema: this.formDetallada.value?.nroDeSistema,
        infoZonas: this.formInfoZonas.value,
        idsCamaras: this.formCamaras.value?.idsCamaras,
        camarasPorZona: this.formCamaras.value?.camaras,
        idDomicilio,
        controlHorario: {
          activo: this.formControlHorario.value?.activo ?? false,
          ignorarArmadosFueraDeHorario:
            this.formControlHorario.value?.ignorarArmadosFueraDeHorario ??
            false,
          ignorarDesarmadosFueraDeHorario:
            this.formControlHorario.value?.ignorarDesarmadosFueraDeHorario ??
            false,
          horarios: this.horariosForm.value,
        },
      };
      await this.aplicarSims(dataAlarma);
      return await this.alarmasService.update(this.id!, dataAlarma);
    } catch (error) {
      this.helper.notifWarn('No pudo actualizarse la alarma');
      console.error(error);
      return null;
    }
  }

  public async update() {
    // Primero la ubicación: si falla, no se toca la alarma (evita estado parcial)
    const ubicacion = await this.upsertUbicacion();
    if (!ubicacion) {
      return null;
    }

    const [alarma, notas, contactos] = await Promise.all([
      this.updateAlarma(ubicacion._id),
      this.updateNotas(),
      this.updateContactos(),
    ]);

    if (!alarma || !notas || !contactos) {
      return null;
    }
    return alarma;
  }

  private setTitles() {
    if (this.alarmaEditar) {
      this.title = 'Editar Alarma';
      this.subtitle = this.alarmaEditar?.nombre;
    } else {
      this.title = 'Crear Alarma';
    }
  }

  //
  async ngOnInit() {
    const params = await firstValueFrom(this.route.paramMap);

    this.id = params.get('id');
    this.tab = params.get('tab');
    // El título desde el principio: setTitles corre después de cargar la
    // alarma y los modelos, y hasta entonces el encabezado quedaba vacío.
    this.title = this.id ? 'Editar Alarma' : 'Crear Alarma';

    if (this.id) {
      // La SIM ahora es una entidad aparte (FK idSim1/idSim2 + virtuals
      // sim1/sim2). Hay que pedir populate para que el form de edición
      // muestre los datos de las SIMs.
      const populate: IPopulate[] = [{ path: 'sim1' }, { path: 'sim2' }];
      const query: IQueryParam = { populate: JSON.stringify(populate) };
      this.alarmaEditar = await this.alarmasService.getById(this.id, query);
    }
    // createForms() sembra formatoDelComunicador buscando el modelo del
    // comunicador[0] por id de forma síncrona — el cache tiene que estar
    // tibio ANTES, no alcanza con disparar la carga en paralelo.
    await firstValueFrom(this.modeloCache.getModelos());

    this.setTitles();
    this.createForms();

    // Preseleccionar el cliente del permiso activo al crear
    if (!this.id) {
      this.formBasica.patchValue({
        idCliente: this.miCliente?._id,
      });
    }
    await this.listarTodo();

    this._matStepperIntl.optionalLabel = 'Opcional';
    this._matStepperIntl.changes.next();

    this.cargando = false;

    // Navegar al tab especificado después de que el stepper esté inicializado
    if (this.tab && this.tab === '7') {
      setTimeout(() => {
        if (this.stepper) {
          // El horario es el último step (el índice varía si el step de
          // cámaras está oculto por falta de módulo)
          this.stepper.selectedIndex = this.stepper.steps.length - 1;
        }
      }, 0);
    }
  }

  ngOnDestroy(): void {
    this.camaras$?.unsubscribe();
    this.domicilio$?.unsubscribe();
    this.ubicaciones$?.unsubscribe();
    this.servicios$?.unsubscribe();
    this.notas$?.unsubscribe();
    this.idClienteCambia$?.unsubscribe();
  }
}
